import { useEffect } from 'react';
import { useFunction } from './useFunction';
import { isDefined } from '../helpers/defined';
export var useInterval = function useInterval(callback, timeout, disabled, initial) {
  if (disabled === void 0) {
    disabled = false;
  }

  if (initial === void 0) {
    initial = false;
  }

  var handler = useFunction(callback);
  useEffect(function () {
    if (disabled || !isDefined(timeout)) {
      return;
    }

    if (initial) {
      handler();
    }

    var intervalId = setInterval(handler, timeout);
    return function () {
      return clearInterval(intervalId);
    };
  }, [timeout, disabled]);
};